<ng-container *ngIf="hasMenu && (canChangeStatus$ | async); else plainPill">
  <div #dropdown="ngbDropdown" ngbDropdown container="body" placement="bottom-start" [popperOptions]="popperOptions">
    <button #toggle type="button" class="status-menu-toggle" ngbDropdownToggle>
      <span class="visually-hidden" i18n>Change status. Current status:</span>
      <span
        class="status-menu-pill"
        [class.status-menu-pill-medium]="size === 'medium'"
        [style.color]="statusPill.primaryColor"
        [style.background-color]="statusPill.secondaryColor"
        [style.border-color]="statusPill.primaryColor">
        {{ statusPill.name }}
        <span class="status-menu-chevron" aria-hidden="true"></span>
      </span>
    </button>
    <div ngbDropdownMenu class="status-menu">
      <div class="status-menu-title" i18n>Change Status</div>
      <button
        *ngIf="option; else monthlyPensionMessage"
        type="button"
        ngbDropdownItem
        class="status-menu-option"
        (click)="selectStatus(dropdown, toggle, option.status)">
        <app-status-pill [statusPill]="option.pill" size="medium" />
        <span class="status-menu-description">{{ option.description }}</span>
      </button>
    </div>
  </div>
</ng-container>

<ng-template #monthlyPensionMessage>
  <div class="status-menu-message">
    <span class="status-menu-info-icon" aria-hidden="true"></span>
    <span class="status-menu-description" i18n>
      A monthly pension's status can't be changed. Changes are made on each payment leg.
    </span>
  </div>
</ng-template>

<ng-template #plainPill>
  <app-status-pill [statusPill]="statusPill" [size]="size" />
</ng-template>
